module.exports = __webpack_public_path__ + "static/media/example-light.73319a97.svg";